import React, { useState, useEffect } from 'react';
import {
  ExpandMore
} from "@mui/icons-material";
import { Accordion, AccordionSummary, AccordionDetails, Divider } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterItem,
  MagicItemKeyword,
} from "@dndModels";

import DataUtilities from '@dndUtilities/data_utilities';
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';
import DandDAPI from '@dndUtilities/system_api';

import CharacterItemMIK from "@dndComponents/character/inventory/CharacterItemMIK";
import SelectObjectBox from '@components/input/selects/SelectObjectBox';
import FilterBox from '@dndComponents/filtering/FilterBox';
import { DisablableOption } from '@models';
import { RARITY_NUM_TO_COLOR_MAP } from '@dndModels/Constants';
import SelectObjectIndex from '@dndComponents/select/SelectObjectIndex';

interface Props {
  character: Character;
  char_item: CharacterItem;

}

const api = DandDAPI.getInstance();
const data_util = DataUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterItemUpgradeControls({
  character,
  char_item,
}: Props) {
  const [ping, setPing] = useState(false);
  const [filter, setFilter] = useState<any>({});
  const [filtering, setFiltering] = useState(false);
  
  const base_item = char_item.base_item;
  if (!base_item) return <></>;

  const possible_mik_ids = base_item.possible_mik_ids;
  const possible_miks = data_util.magic_item_keywords.filter(o =>
    possible_mik_ids.includes(o._id)
  );
  if (possible_miks.length === 0) return <></>;

  const included_ids = new Set(char_item.magic_item_keyword_ids);

  const filtered_miks = api.filter("magic_item_keyword", possible_miks, filter);

  const filtered_ids = filtered_miks.filter(o => !included_ids.has(o._id)).map(o => o._id);

  const updateFilter = (the_filter: any, startLetter = "") => {
    // debugger;
    const new_filter = {...the_filter};
    
    if (startLetter !== "") {
      new_filter["name*startsWith"] = startLetter;
    } else {
      delete new_filter["name*startsWith"];
    }

    setFilter(new_filter);
    setFiltering(true);
  }

  const handleAddMIK = async (mik_id: string) => {
    if (!mik_id || mik_id === "") return;
    await connect_util.connectMagicItemKeyword({
      char: character,
      char_item_or_id: char_item,
      magic_item_keyword_or_id: mik_id,
      source_id: "",
      char_feature_id: ""
    });
    character.changed();
    character.subscription_holder.itemsChanged();
    setPing(!ping);
  };

  const triggerReload = () => {
    character.changed();
    character.subscription_holder.itemsChanged();
    setPing(!ping);
  };

  return (
    <Grid size={12} className="header padded">
      <Accordion>
        <AccordionSummary
          style={{ fontWeight: "bold", height: "30px" }}
          expandIcon={<ExpandMore />}>
          Manage Upgrades
        </AccordionSummary>
        <AccordionDetails>
          <div className="padded" style={{ width: "100%", border: "1px solid", backgroundColor: "black" }}>
            <Grid container spacing={0} direction="row">

              {/* ── Included MIKs ── */}
              { char_item.char_magic_item_keywords
                .sort((a, b) => {
                  if (a.min_rarity !== b.min_rarity) return a.min_rarity - b.min_rarity;
                  return a.name.localeCompare(b.name);
                })
                .map(cmik => (
                  <Grid size={12} key={cmik.true_id}>
                    <CharacterItemMIK
                      character={character}
                      char_item={char_item}
                      cmik={cmik}
                      onChange={triggerReload}
                    />
                  </Grid>
                ))
              }

              {/* ── Divider (only when both sections are non-empty) ── */}
              {char_item.char_magic_item_keywords.length > 0 && included_ids.size > 0 && (
                <Grid size={12} style={{ margin: "6px 0" }}>
                  <Divider />
                </Grid>
              )}


              {/* ── Add new MIK ── */}
              { possible_miks.length > 0 && (
                <>
                  <Grid size={12} className="header centered">
                    Add Magic Item Keyword
                  </Grid>
                  <Grid size={12}>
                    <FilterBox
                      data_type="magic_item_keyword"
                      onChange={updateFilter}
                      onLoad={updateFilter}
                      // log_it
                      all_objects={possible_miks}
                      quick_fields={["rarities","attunement"]}
                    />
                  </Grid>
                  <Grid size={12}>
                    <SelectObjectIndex
                      values={[]}
                      data_type="magic_item_keyword"
                      extra_filter={(o) => {
                        return filtered_ids.includes(o._id);
                      }}
                      filter={filter}
                      updateFilter={updateFilter}
                      // optionConvert={(o) => {
                      //   if (o instanceof MagicItemKeyword) {
                      //     const opt: DisablableOption = {
                      //       id: o._id,
                      //       text: o.name,
                      //       color: RARITY_NUM_TO_COLOR_MAP[o.min_rarity]
                      //     };
                      //     return opt;
                      //   }
                      //   return { id: "", text: "" };
                      // }}
                      onChange={(changed) => {
                        handleAddMIK(changed[0]);
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
